import { render, staticRenderFns } from "./CollectionPanel.vue?vue&type=template&id=d094fbee&"
import script from "./CollectionPanel.vue?vue&type=script&lang=js&"
export * from "./CollectionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports